import { z } from "zod";

export const AcknowledgeAlarmRequestSchema = z.object({
  cause: z.string().min(1).max(500),
});
export type AcknowledgeAlarmRequest = z.infer<typeof AcknowledgeAlarmRequestSchema>;

export const MarkFalseAlarmRequestSchema = z.object({
  falseJustify: z.string().min(1).max(500),
});
export type MarkFalseAlarmRequest = z.infer<typeof MarkFalseAlarmRequestSchema>;

export const ListAlarmsQuerySchema = z.object({
  state: z.enum(["UNACKNOWLEDGED", "ACKNOWLEDGED", "RESOLVED", "SHELVED"]).optional(),
  severity: z.enum(["LOW", "MEDIUM", "HIGH"]).optional(),
  // True → apenas alarmes oscilando. "true"/"false" explícitos (z.coerce.boolean
  // faria Boolean("false") === true e inverteria o filtro para chamadas diretas da API).
  flapping: z
    .enum(["true", "false"])
    .transform((v) => v === "true")
    .optional(),
  includeSuppressed: z.coerce.boolean().default(false),
  includeResolved: z.coerce.boolean().default(false),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
